export const environment = {
  production: false,
  apiBase: 'https://api.dev.argon.band',
};
